export const Logo = (props: { width?: string; height?: string; animate?: boolean }) => {
  return (
    <>
      <img
        src="/logo.png"
        width={props.width ? props.width : "auto"}
        height={props.height ? props.height : "auto"}
        style={{
          animation: props.animate ? "logo-rotating 10s linear infinite alternate" : undefined,
        }}
      />
      <style>
        {`
          @keyframes logo-rotating {
            from {
              transform: rotate(20deg);
            }
            to {
        
              transform: rotate(-90deg);
            }
            }
        `}
      </style>
    </>
  );
};
